// =============================================
// authGuard — central handling for an expired/invalid session.
// =============================================
// When an authenticated API call comes back 401, the app must NOT silently fall
// back to stale localStorage (that's what made an expired session look like
// "data loss"). Instead we clear the dead session and bounce the user to /auth
// with a flag so the login screen can explain what happened.
// =============================================

let handled = false;

/** Called when the API reports the session is invalid/expired (HTTP 401). */
export function handleSessionExpired(): void {
  if (handled) return;          // ignore the stampede of 401s from parallel loads
  handled = true;
  try {
    localStorage.removeItem('akt_auth_token');
    localStorage.removeItem('akt_refresh_token');
    localStorage.removeItem('akt_session_user');
    document.cookie = 'akt_session=; path=/; max-age=0';
    sessionStorage.setItem('akt_session_expired', '1');
  } catch { /* storage may be unavailable */ }
  if (typeof window !== 'undefined' && !/\/auth\b/.test(window.location.pathname)) {
    window.location.assign('/auth');
  }
}

/** Did we just bounce here because the session expired? (one-shot read) */
export function consumeSessionExpiredFlag(): boolean {
  try {
    const v = sessionStorage.getItem('akt_session_expired');
    if (v === '1') { sessionStorage.removeItem('akt_session_expired'); return true; }
  } catch { /* ignore */ }
  return false;
}
